import React, { useState, useContext } from 'react';
import { WelletContext } from '../../../context/WelletContext';
import { getQueryString } from '../../../helpers/url';
import { CircleSpinner } from 'react-spinners-kit';
import { getStripeOnboardingRefreshLink } from '../../../services/withdrawal/withdrawalService';

const StripeOnboardingRefresh = () => {
  const token = getQueryString('t');
  const welletContext = useContext(WelletContext);

  const getAndRefreshUrl = async () => {
    var decodedToken = decodeURIComponent(token);
    var newLink = await getStripeOnboardingRefreshLink(welletContext, decodedToken);
    window.location.href = newLink;
    return newLink;
  };

  const [newLink] = useState(() => {
    getAndRefreshUrl();
  });

  return (
    <div className="loaderDiv">
      <CircleSpinner
        className="spinner-app mx-auto"
        style={{ margin: 'auto' }}
        size={40}
        color="#503ec4"
      />
    </div>
  );
};

export default StripeOnboardingRefresh;
